import Text from '@/components/atoms/Text';
import * as S from './styles';
import formatarMoeda from '@/utils/formatarMoeda';
import IconButton from '@/components/atoms/IconButton';
import { IconeCarrinho } from '@/components/atoms/Icones/IconeCarrinho';
import Button from '@/components/atoms/Button';
import { CheckoutContainerProps } from '../..';

export default function CheckoutContainerDesktop(
  props: CheckoutContainerProps,
) {
  const {
    $valorTotal,
    $funcaoAdicionarAoCarrinho,
    $funcaoAcaoPrincial,
    $textoBotaoAcaoPrincipal,
    $permitirUsuarioRealizarCompra,
  } = props;

  return (
    <S.Container>
      <S.ContainerDetalhamentoValores>
        <Text
          $size={6}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={formatarMoeda({
            valor: $valorTotal,
          })}
          $quebraTexto={false}
        />
        <Text
          $size={3}
          $color="neutral"
          $weight="medium"
          $align="left"
          $highContrast={false}
          $text={'Subtotal'}
          $quebraTexto={false}
        />
      </S.ContainerDetalhamentoValores>
      <S.ContainerLinhaBotoes>
        {$permitirUsuarioRealizarCompra ? (
          <div>
            <IconButton
              $Icon={IconeCarrinho}
              $size={1}
              $state="default"
              $variant="soft"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $focusRing={false}
              $onClick={$funcaoAdicionarAoCarrinho}
              style={{ justifyContent: 'center', padding: 10 }}
            />
          </div>
        ) : null}
        <Button
          style={{ justifyContent: 'center', width: '100%' }}
          $size={2}
          $variant="solid"
          $color="accent"
          $highContrast={false}
          $loading={false}
          $focusRing={false}
          $disable={!$permitirUsuarioRealizarCompra}
          $text={$textoBotaoAcaoPrincipal}
          $onClick={$funcaoAcaoPrincial}
        />
      </S.ContainerLinhaBotoes>
    </S.Container>
  );
}
